/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBorderCornerRounded = createReactComponent(
  "border-corner-rounded",
  "IconBorderCornerRounded",
  [["path", { d: "M4 20v-10a6 6 0 0 1 6 -6h10", key: "svg-0" }]]
);

export { IconBorderCornerRounded as default };
//# sourceMappingURL=IconBorderCornerRounded.js.map
